// extracted by mini-css-extract-plugin
export default {"link":"NE02FvVv"};